import { Component, LOCALE_ID, OnInit, Inject, Injector } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { User, UserManager, WebStorageStateStore } from 'oidc-client-ts';
import { Observable } from 'rxjs';

import { AuthenticationService } from '../core/authentication/authentication.service';
import { RealTimeNotificationService } from '@app/shared/services/realTimeNotification/real-time-notification.service';
import { SignalrService } from '@app/core/signalr.service';
import { environment } from '@env/environment';
import { ToastService } from '@app/shared/services/toast/toast.service';
import { NgxPermissionsService, NgxPermissionsObject } from 'ngx-permissions';
import { MyStartupService } from '@app/app.service';
import { LoaderService } from './../core/loader.service';
import { NotificationsService } from '@app/shared/services/notifications.service';
import { Guid } from 'guid-typescript';
import { HttpClient } from '@angular/common/http';
import { AuthServiceCleaner } from '@app/shared/services/auth.service.cleaner';
import { IdleTimeoutService } from '@app/shared/services/idle-timeout.service';
import { AppConfig } from 'src/global.config';
import { LocaleService } from '@app/shared/services/locale.service';
import { LocaleId } from '@app/shared/services/locale.provider';
import { KeycloakService } from 'keycloak-angular';
import { KeycloakProfile } from 'keycloak-js';
import jwtDecode from 'jwt-decode';
import { NgForageCache } from 'ngforage';
import { RootService } from '@app/core/authentication/root.service';
import { AppConfigurationService } from '@app/shared/services/app.configuration.service';
import { Identifiers } from '@app/shared/services/app.config.type';
import moment from 'moment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  identity$: Observable<User>;
  loggedIn$: Observable<boolean>;
  loading$: Observable<boolean>;
  expiring$: Observable<boolean>;
  expired$: Observable<boolean>;
  errors$: Observable<any>;

  public identity: any;
  public isLoggedIn = false;
  public userProfile: KeycloakProfile | null = null;

  error: string = undefined;
  ngForage: NgForageCache;
  permissions: NgxPermissionsObject;

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private realTimeNotificationService: RealTimeNotificationService,
    private signalRService: SignalrService,
    private toastService: ToastService,
    private keycloak: KeycloakService,
    private idleTimeoutService: IdleTimeoutService,
    private http: HttpClient,
    private authClearService: AuthServiceCleaner,
    private route: ActivatedRoute,
    private ngxpermissions: NgxPermissionsService,
    private myStartupService: MyStartupService,
    private loaderService: LoaderService,
    public appConfig: AppConfigurationService,
    private notificationsService: NotificationsService, // private i18nService: I18nService,
    private localeService: LocaleService,
    public injector: Injector,
    private rootService: RootService,
    @Inject(LOCALE_ID) public localeId: LocaleId
  ) {
    this.ngForage = this.injector.get(NgForageCache);
  }

  async ngOnInit() {
    // if (this.authService.checkIsSSOUserFlow()) {
    //   this.router.navigate(['/sso']);
    //   return;
    // }

    this.checkIsIdletimeoutSet();
    this.checkIsTokenExpired();
  }

  checkIsTokenExpired() {
    let isTokenExpired = JSON.parse(localStorage.getItem('isTokenExpired'));
    if (isTokenExpired && isTokenExpired == true) {
      window.localStorage.clear();
      this.authService.signoutRedirect();
      return;
    } else {
      this.checkTenantName();
    }
  }

  checkIsIdletimeoutSet() {
    let isIdleTimeout = JSON.parse(localStorage.getItem('isIdleTimeout'));
    let isUserReloggedIn = JSON.parse(localStorage.getItem('isUserReloggedIn'));
    if (isIdleTimeout && isIdleTimeout == true) {
      window.localStorage.clear();
      this.authService.signoutRedirect();
      return;
    } else if (isUserReloggedIn && isUserReloggedIn == true) {
      localStorage.removeItem('isUserReloggedIn');
      this.router.navigate(['/post-logout']);
    }
  }

  checkTenantName() {
    let tenantName = this.route.snapshot.paramMap.get('id');
    if (!tenantName && this.authService.authData == null) {
      if (environment.login.isDefaultEnabled) {
        tenantName = environment.login.defaultRouteValue;
      }
    }
    if (tenantName) {
      if (this.authService.authData == null) {
        if (this.authService.getTenantName() == null || tenantName !== this.authService.getTenantName()) {
          localStorage.setItem('tenant', tenantName);
        }
        this.authService.init();
        this.initLogin();
      } else {
        this.authService.init();
        this.initLogin();
      }
    } else {
      localStorage.setItem('tenant', '');
      this.authService.init();
      this.initLogin();
    }
  }

  async initLogin() {
    this.loaderService.showMain = true;
    this.checkIsIdletimeoutSet();
    if (await this.authService.isUserLoggedIn()) {
      // this.authService.checkTokenExpiry(user.expires_at);
      this.isLoggedIn = true;
      this.authService.isLoggedIn = true;
      // No loadUserProfile() here: it is an extra Keycloak /account request and the profile isn't used.
      this.identity = this.keycloak.getKeycloakInstance().tokenParsed;
      this.keycloak.getToken().then((token: any) => {
        this.initUser(token);
      });
    } else {
      this.isLoggedIn = false;
      this.authService.isLoggedIn = false;
      this.identity = '';
      if (this.authService.isSetLoggedOut === false) {
        this.authService.clearAuthData();
        localStorage.setItem('isSSOLogin', null);
        localStorage.setItem('ssoClient', null);
        localStorage.setItem('ssoToken', null);
        localStorage.setItem('isIdleTimeout', null);
        localStorage.setItem('idle_timeout_enabled', null);
        this.authService.signinRedirect();
      } else {
        this.router.navigate(['/unauthorized']);
      }
    }
  }
  // initLogin() {
  //   this.loaderService.showMain = true;
  //   this.checkIsIdletimeoutSet();

  //   this.authService.getCurrentUser().subscribe({
  //     next: (user) => {
  //       if (user) {
  //         this.authService.checkTokenExpiry(user.expires_at);
  //         this.isLoggedIn = true;
  //         this.authService.isLoggedIn = true;
  //         this.identity = user;
  //         this.initUser();
  //       } else {
  //         this.isLoggedIn = false;
  //         this.authService.isLoggedIn = false;
  //         this.identity = '';
  //         if (this.authService.isSetLoggedOut === false) {
  //           this.authService.clearAuthData();
  //           localStorage.setItem('isSSOLogin', null);
  //           localStorage.setItem('ssoClient', null);
  //           localStorage.setItem('ssoToken', null);
  //           localStorage.setItem('isIdleTimeout', null);

  //           localStorage.setItem('idle_timeout_enabled', null);
  //           this.authService.signinRedirect();
  //         } else {
  //           this.router.navigate(['/endsession']);
  //         }
  //       }
  //     },
  //     error: (e) => {
  //       console.log(e);
  //       this.loaderService.showMain = false;
  //       this.router.navigate(['/oops']);
  //     },
  //   });
  // }

  login() {
    this.authService.login();
  }

  initUser(token: string = null) {
    let tokenDecoded: any;

    if (token) tokenDecoded = jwtDecode(token);

    const res = {
      access_token: token,
      expiry: tokenDecoded?.exp,
    };

    if (tokenDecoded.IsSSO) {
      // ClientId is a token claim and ClientName comes from a hardcoded "ClientName" claim mapper on the SSO realm,
      // so no /client/Getclient round trip is needed. Realms without that mapper yet still fall back to Getclient.
      if (tokenDecoded.ClientName && tokenDecoded.ClientId) {
        this.provisionSsoUser(
          { ClientName: String(tokenDecoded.ClientName).toUpperCase(), ClientId: tokenDecoded.ClientId },
          res
        );
      } else {
        this.authService.getClient().subscribe((client: any) => {
          if (client) {
            this.provisionSsoUser({ ClientName: client.Name.toUpperCase(), ClientId: client.Id }, res);
          } else {
            this.router.navigate(['/unauthorized']);
          }
        });
      }
    } else {
      this.processlogin(res);
    }
  }

  //// create sso user if not exist, then continue the normal login
  private provisionSsoUser(param: { ClientName: string; ClientId: string }, res: any) {
    this.authService.ssoUserProvision(param).subscribe((response: any) => {
      this.processlogin(res);
    });
  }

  private processlogin(res: any) {
    //// set default user language
    Promise.all([
      (window as any).getTranslationsUserWise(res.access_token, environment.apiUrl),
      (window as any).getOrgList(res.access_token, environment.apiUrl),
      (window as any).getUserClaims(res.access_token, environment.apiUrl),
    ]).then(([translations, orgList, userClaims]) => {
      const defaultLanguage = translations.data.LanguageCode;
      (window as any).setLanguage(defaultLanguage);
      this.localeService.setDefaultLocale(defaultLanguage);
      this.localeService.setLocale(defaultLanguage);
      const response = userClaims.data;
      this.authService.storeAuthData(res).subscribe((_) => {
        this.authService.onSignIn(response);
        if (response && response.IdleTimeoutConfig != null && response.IdleTimeoutConfig.IsIdletimeoutEnabled) {
          this.idleTimeoutService.setIdletimeout(response.IdleTimeoutConfig.TimeoutSeconds);
        }

        if (environment.signalRConfigured) {
          this.signalRService.init();
          this.realTimeNotificationService.init();
          this.realTimeNotificationService.subscribeListeners();
        }
        const langResponse = translations.data;
        const res = orgList.data;
        this.authService.getEmpty().subscribe(async (_: any) => {
          if (res && res.length !== 0) {
            // this.authService.orgListData = this.treeToLinearN(res);
            this.loaderService.setMain(true);
            await this.ngForage.setItem('orgs_raw', res);
            // this.authService.orgs = await this.treeToLinearNAsync(res);
            // await this.ngForage.setItem('orgs', this.authService.orgs);
            this.loaderService.setMain(false);
          }

          this.myStartupService.data = langResponse;
          // localStorage.setItem('translations', JSON.stringify(langResponse));
          localStorage.setItem('translations', JSON['makeStringify'](langResponse));
          this.permissions = this.ngxpermissions.getPermissions();
          const Admin = this.permissions['Admin'] ? true : false;
          const Reporting = this.permissions['Reporting'] ? true : false;

          this.loaderService.showMain = false;
          if (localStorage.getItem('loginNotificationId') == null) {
            const id: string = Guid.create().toString();
            localStorage.setItem('appNotifyId', id);
            const notifyData = { message: 'Login Successfull', pageName: 'Login', module: 'Login', appNotifyId: id };
            this.notificationsService.ActivityNonRequestNotification(notifyData, true);
          }
          if (Reporting) {
            this.getConfiguration('gf', 'Global Filter').then((filterCOnfiguration) => {
              this.router.navigate(['/' + environment.reportingRoutePrefix]);
            });
            this.authService.portalTheme.allowModuleThemeSetting = false;
          } else if (Admin) {
            this.getConfiguration('gf', 'Global Filter').then((filterCOnfiguration) => {
              this.router.navigate(['/' + environment.reflecxRoutePrefix]);
            });
            this.authService.portalTheme.allowModuleThemeSetting = true;
          } else {
            this.router.navigate(['/unauthorized']);
          }
          if (this.appConfig.getByIdentifier('Portal.Themes')) {
            this.authService.applyPortalTheme(
              this.appConfig.getByIdentifier('Portal.Themes'),
              response.UserPortalColor
            );
          }
        });
      });
    });
  }

  private getConfiguration(id: string, module: string) {
    return new Promise((resolve, reject) => {
      const user = this.authService.getUser();
      const globalConfig = user.FilterBarConfig.FilterConfig.config;
      if (!user) {
        return resolve(true);
      }
      const url = `/configuration?Id=${id}&UserId=${user.Id}&ClientId=${user.ClientId}&Module=${module}`;
      return this.http
        .disableLoader()
        .disableHttpCancel()
        .get<any>(url)
        .subscribe({
          next: async (configuration: any) => {
            if (configuration && configuration.Settings) {
              const object = configuration.Settings;
              for (const property in object) {
                const config: any = globalConfig.find((config: any) => {
                  return config.localStorageKey == property;
                });
                const ignoreConfig = ['gbf_org', 'gbf_loginsummary_org'];
                const activeQPDG: any = this.appConfig.getByIdentifier('active-qp-dg');
                let defaultVersionSelection = false;
                let defaultModelYearSelection = false;
                let defaultCalendarSelection = false;
                let defaultMulliganSelection = false;
                let defaultChannelSelection = false;
                let defaultSurveyTypeSelection = false;
                if (activeQPDG['Fields'] && activeQPDG['Fields'] && activeQPDG['Fields']['defaultVersionSelection']) {
                  defaultVersionSelection = activeQPDG['Fields']['defaultVersionSelection'];
                }
                if (activeQPDG['Fields'] && activeQPDG['Fields'] && activeQPDG['Fields']['defaultOlderSelection']) {
                  defaultModelYearSelection = activeQPDG['Fields']['defaultOlderSelection'];
                }
                if (activeQPDG['Fields'] && activeQPDG['Fields'] && activeQPDG['Fields']['defaultCalendarSelection']) {
                  defaultCalendarSelection = activeQPDG['Fields']['defaultCalendarSelection'];
                }
                if (activeQPDG['Fields'] && activeQPDG['Fields'] && activeQPDG['Fields']['defaultMulliganSelection']) {
                  defaultMulliganSelection = activeQPDG['Fields']['defaultMulliganSelection'];
                }
                if (activeQPDG['Fields'] && activeQPDG['Fields'] && activeQPDG['Fields']['defaultChannelSelection']) {
                  defaultChannelSelection = activeQPDG['Fields']['defaultChannelSelection'];
                }
                if (
                  activeQPDG['Fields'] &&
                  activeQPDG['Fields'] &&
                  activeQPDG['Fields']['defaultSurveyTypeSelection']
                ) {
                  defaultSurveyTypeSelection = activeQPDG['Fields']['defaultSurveyTypeSelection'];
                }
                if (defaultVersionSelection) {
                  ignoreConfig.push('gbf_version');
                }
                if (defaultModelYearSelection) {
                  ignoreConfig.push('gbf_multi_mby');
                }
                if (defaultCalendarSelection) {
                  localStorage.setItem('gbf_date_identifier', 'MTD');
                  let updatedDates = [moment().startOf('month').format('MMM D, YYYY'), moment().format('MMM D, YYYY')];
                  let updatedObject = updatedDates.join('|');
                  localStorage.setItem('gbf_calendar', updatedObject);

                  // ignoreConfig.push('gbf_calendar');
                  // if (localStorage.getItem('filter_date')) {
                  //   console.log('filter_date')
                  //   localStorage.removeItem('filter_date')
                  // }
                  // if (localStorage.getItem('gbf_calendar')) {
                  //   console.log('gbf_calendar')
                  //   localStorage.removeItem('gbf_calendar')
                  // }
                  // if (localStorage.getItem('gbf_date_identifier')) {
                  //   console.log('gbf_date_identifier')
                  //   localStorage.removeItem('gbf_date_identifier')
                  // }
                }

                if (defaultMulliganSelection) {
                  ignoreConfig.push('gbf_mulligan');
                }
                if (defaultChannelSelection) {
                  ignoreConfig.push('gbf_channels');
                }
                if (defaultSurveyTypeSelection) {
                  ignoreConfig.push('gbf_surveytype');
                }
                if (config && !ignoreConfig.includes(config.localStorageKey)) {
                  if (config?.database === 'indexdb') {
                    try {
                      const parsed = JSON.parse(object[property]);
                      localStorage.setItem(property, JSON.stringify({ selected: parsed.selected }));
                    } catch (error) {}
                    await this.ngForage.setItem(property, object[property]);
                  } else {
                    localStorage.setItem(property, object[property]);
                  }
                  localStorage.setItem(property, object[property]);
                  // this.gbfService[property + '_full'] = object[property];
                  // this.gbfService[property + '_breadcrums'] = object[property].breadcrums;

                  const identifier = object.gbf_date_identifier || config?.range || 'MTD';
                  if (config.localStorageKey === 'gbf_calendar') {
                    localStorage.setItem('gbf_date_identifier', identifier);
                    if (identifier.toLowerCase() !== 'custom range') {
                      let dateDropDownOptions = this.rootService.getCalenderDropDownOptions();
                      if (identifier.toLowerCase() === 'program to date') {
                        const programDate = this.appConfig.getByIdentifier(Identifiers.ProgramDate);
                        if (programDate) {
                          if (programDate.ClientConfig === null) {
                            programDate.ClientConfig = programDate;
                          }
                          if (programDate.ClientConfig) {
                            const dateValue = new Date(programDate.ClientConfig.Fields['equal']['value']);
                            if (dateValue) {
                              let progamToDateArray = [
                                moment(dateValue).format('MMM D, YYYY'),
                                moment().format('MMM D, YYYY'),
                              ];
                              let updatedObject = progamToDateArray.join('|');
                              object[property] = updatedObject;
                            }
                          }
                        }
                      } else {
                        let selectedOption = dateDropDownOptions.filter((item: any) => {
                          return item.key.toLowerCase() === identifier.toLowerCase();
                        });
                        selectedOption =
                          selectedOption.length === 0
                            ? [
                                {
                                  label: 'MTD',
                                  key: 'MTD',
                                  value: (value: any = moment()) => [moment(value).startOf('month'), moment()],
                                },
                              ]
                            : selectedOption;

                        let updatedDates = object[property].split('|');
                        updatedDates[0] = selectedOption[0].value()[0].format('MMM D, YYYY');
                        updatedDates[1] = selectedOption[0].value()[1].format('MMM D, YYYY');
                        let updatedObject = updatedDates.join('|');
                        object[property] = updatedObject;
                      }
                    }
                  }
                }
              }
              return resolve(true);
            } else {
              return resolve(true);
            }
          },
          error: (e) => {
            return resolve(true);
          },
        });
    });
  }

  private treeToLinearNAsync(list: any[]) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        this.treeToLinearN(list, (t: any) => {
          resolve(t);
        });
      }, 0);
    });
  }

  private treeToLinearN(list: any, complte: any): Array<any> {
    const orgData: Array<any> = [];
    let treeToLinearN: Array<any> = [];
    list = list.sort((a: any, b: any) => a.Level - b.Level);
    list.forEach((element: any) => {
      if (element.ParentIds.length == 0) {
        let insertElement: any = {
          id: element.Id,
          level: element.Level,
          label: element.Label,
          name: element.Label,
          value: element.NodeId,
          Title: element.Title,
          NodeName: element.Name,
          hasChild: true,
          orginalLevel: element.Level,
          mProps: element.mProps || {
            ...element,
            title: element.Title,
            NodeName: element.Name,
            hasChild: true,
          },
        };
        orgData.push({ ...insertElement, parent: null });
      } else {
        element.ParentIds.forEach((id: string) => {
          let insertElement: any = {
            id: element.Id,
            level: element.Level,
            label: element.Label,
            name: element.Label,
            value: element.NodeId,
            Title: element.Title,
            NodeName: element.Name,
            hasChild: false,
            orginalLevel: element.Level,
            mProps: element.mProps || {
              ...element,
              title: element.Title,
              NodeName: element.Name,
              hasChild: false,
            },
          };
          insertElement.mProps.parent = id;
          orgData.push({ ...insertElement, parent: id });
          const parentData = orgData.filter((el) => {
            return el.id == id;
          });
          if (parentData.length !== 0) {
            parentData.forEach((linearObj) => {
              linearObj['hasChild'] = true;
              insertElement.mProps['hasChild'] = true;
            });
          }
        });
      }
    });
    const DataAccessLevels = Array.isArray(this.authService?.authData?.DataAccessLevels)
      ? this.authService.authData.DataAccessLevels
      : [];
    const parentId = DataAccessLevels.length >= 1 ? DataAccessLevels[0].ParentId : null;
    if (parentId && orgData.length !== 0) {
      const treeSelection: any = [];
      DataAccessLevels.forEach((dataAccessLevel: any) => {
        let dataFromParent: any = orgData.find((x: any) => x.parent == dataAccessLevel.ParentId);
        if (dataFromParent) {
          treeSelection.push(dataFromParent);
          do {
            dataFromParent = orgData.find((x: any) => x.id == dataFromParent?.parent);
            const isData = treeSelection.some((x: any) => x.id == dataFromParent?.id);
            if (!isData) {
              treeSelection.push(dataFromParent);
            }
          } while (dataFromParent?.parent);
        }
      });
      orgData.forEach((res: any) => {
        if (DataAccessLevels[0].Level < res.level) {
          treeToLinearN.push(res);
        }
      });
      treeToLinearN = treeToLinearN.concat(treeSelection);
      treeToLinearN = treeToLinearN.sort((a: any, b: any) => a.level - b.level);
    } else {
      treeToLinearN = orgData;
    }
    complte(treeToLinearN);
    return treeToLinearN;
  }
}
